<template>
  <div>
    <div class="proddress_box" @click="toprojectAddress()" v-if="addressItem">
      <div class="proaddress_left">
        <img class="proaddress_img" src="/static/weizhi.png" />
        <div class="proaddress_mesg">
          <div class="proaddress_top">
            <div class="proaddress_name">{{addressItem.addressee}}</div>
            <div class="proaddress_phone">{{addressItem.mobile}}</div>
          </div>
          <div class="proaddress_address">{{addressItem.province}}{{addressItem.city}}{{addressItem.district}}{{addressItem.address}}</div>
        </div>
      </div>
      <img class="proaddress_rightimg" src="/static/xiangyou.png" />
    </div>
    <div v-else class="proddress_box" @click="toprojectAddress()">
      <div class="proaddress_left">
        收货地址
      </div>
      <div class="proaddress_right1">
        <div class="moren">请选择收货地址</div>
        <img class="proaddress_rightimg" src="/static/xiangyou.png" />
      </div>
    </div>
    <div class="prodetail_mesg">
      <div class="prodetailmesg_top">
        <img class="prodetailmesg_icon" src="/static/newprojecticon/title.png" />
        <div class="prodetailmesg_title">以下商品已享受包邮服务</div>
      </div>
      <div class="prodetailmesg_center">
        <div class="prodetail_photo">
          <img class="prodetailmesg_phimg" :src="buymesg.thumb" />
        </div>
        <div class="prodetailmesg_mesg">
          <div class="prodetailmesg_name">{{buymesg.name}}</div>
          <div class="prodetailmesg_guige">
            <div class="prodetailmesg_morenguige">规格：{{buymesg.id=='224' ? buymesg.notes :  '默认' }}</div>
            <div class="prodetailmesg_num">X{{buymesg.nums}}</div>
          </div>
          <div class="prodetailmesg_price">￥{{buymesg.totalPrice}}</div>
        </div>
      </div>
      <div class="prodetailmesg_bottom">
        <div class="prodetailmesg_heji">合计</div>
        <div class="prodetailmesg_pricemum">￥{{buymesg.totalPrice}}</div>
      </div>
    </div>
    <!-- <div class="prodetailpay">
			<div class="prodetailmesg_top">
				<img class="prodetailmesg_icon" />
				<div class="prodetailmesg_title"></div>
			</div>
			<div class="prodetailpay"></div>
		</div> -->
    <div class="prodetail_liuyan" v-if="buymesg.id!='224'">
      <div class="prodetailmesg_top">
        <img class="prodetailmesg_icon" src="/static/newprojecticon/title.png" />
        <div class="prodetailmesg_title">给卖家留言</div>
      </div>
      <textarea placeholder="请输入备注" v-model="remarks" class="prodetail_beizhu"></textarea>
    </div>
    <!-- <div class="prodetail_payamount">
      <div class="prodetailmesg_top">
        <img src="/static/jifenpay.png" class="jifenlogo" />
        <div class="prodetailmesg_title">是否使用余额支付</div>
      </div>
      src="/static/checkdeicon.png"
      <img class="pay_checkbox" src="/static/checkicon.png"  />
    </div> -->
    <!-- <div class="tiptest">提示：未选择使用余额支付会使用“微信支付”，选择余额支付如果积分不够将使用“微信+余额”组合支付</div> -->
    <div class="prodetailbuy_buttom">
      <div class="prodetailbuy_paynum" v-if="buymesg.id=='224'">应付金额：￥0.00</div>
      <div class="prodetailbuy_paynum" v-else>应付金额：￥{{buymesg.totalPrice}}</div>
      <div class="prodetailbuy_paybotton" @click="pay1()">立即付款</div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        addressItem: "", //地址列表传来的地址信息
        buymesg: "", //购买商品信息
        amount: "" ,//余额
        remarks:"",//备注
        jifenpay:false,
        actualPaymen:0,//微信应付金额
        totalMoney:0,//实际支付金额
        img:'',//id==224的商品图片
      }
    },
    created() {
      if (this.$route.query.addressItem) {
        this.addressItem = JSON.parse(this.$route.query.addressItem)
      }else{
        this.request("getdefaultAddress")
      }
      if (this.$route.query.buymesg) {
        this.buymesg = JSON.parse(this.$route.query.buymesg)
        this.totalMoney = this.buymesg.totalPrice
      }
      if(this.buymesg.id=='224'){
        this.remarks = this.buymesg.notes
        this.img = this.buymesg.img
      }
      console.log("buy", this.buymesg)

    },
    mounted() {

    },
    methods: {
      toprojectAddress() {
        let that = this
        that.$router.push({
          path: "/projectAddressList",
          query: {
            isbuy: true,
            buymesg: JSON.stringify(this.buymesg)
          }
        })
      },
       //是否使用积分支付
        userjifenpay() {
          let that = this
          if (that.jifenpay) {
            that.jifenpay = false
            that.actualPaymen = that.totalMoney
          } else {
            that.jifenpay = true
            let actualpaymen = that.actualPaymen //需要微信支付的金额
            if (that.jifenpay) {
              if (that.amount >= that.totalMoney) {
                actualpaymen = 0
              } else {
                actualpaymen = (parseFloat(that.totalMoney) - parseFloat(that.amount)).toFixed(2)
              }
            }
            that.actualPaymen = actualpaymen
          }
        },
      pay1() {
        // Dialog.confirm({
        //   title: '提示',
        //   message: '确定购买？',
        // }).then(() => {
        //   // that.request('delAddress', requestData)
        // }).catch(() => {
        //   return false;
        // });type=mall&pay_type=balance&product_id=99&nums=1&address_id=1
        let that = this
        let requestData = {}
        requestData.type = "mall"
        requestData.product_id = that.buymesg.id
        requestData.nums = that.buymesg.nums
        requestData.address_id = that.addressItem.id
        requestData.remark = that.remarks
        requestData.amount = that.amount
        if(!that.addressItem){
          this.$toast({
            message: '请选择地址'
          })
          return
        }
          if (parseFloat(that.amount) < parseFloat(that.buymesg.totalPrice)) {
            Dialog.confirm({
              title: '提示',
              message: '积分不足，前往充值？',
            })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
              title: '提示',
              message: '是否用余额支付?',
            })
              .then(() => {
                requestData.pay_type = "balance"
                that.request('payProduct', requestData)
              })
              .catch(() => {
                return false;
              });
          }

      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'payProduct':
            httper.post('/payment/place-order', requestData, res => {
              if (res.code == 0) {
                this.$toast({
                  message: '购买成功'
                })
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
            case 'WxunifiedOrder':
              httper.post('/payment/place-order', requestData, res => {
                console.log("微信支付信息", res)
                if (res.code === 0) {
                  if(res.data.payment_packet){
                    that.pay(res.data.payment_packet, res.data.order_no)
                  }else{
                    this.$toast({
                      message: '下单成功',
                    })
                    that.$router.push({
                      path: '/orderListDetail',
                      query: {
                        id: res.data.order_no
                      }
                    })
                  }
                } else {
                  this.$toast({
                    message: res.message || '系统异常',
                  })
                }
              }, true)
              break
              //微信取消下单
            case 'orderCancel':
              httper.post('/order/cancel', requestData, res => {
                console.log("取消", res)
                if (res.code === 0) {
                  // that.pay(res.data.payment_packet, res.data.order_no)
                } else {
                  this.$toast({
                    message: res.message || '系统异常',
                  })
                }
              }, true)
              break
            //获取个人信息余额
          case 'getUserInfo':
            //获取个人信息余额
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code == 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                console.log('amount1', amount1)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
			//获取默认地址
			case 'getdefaultAddress':
			  httper.get('/user/default-address', requestData, res => {
			    if (res.code == 0) {
			      that.addressItem = res.data
			    } else {
			      this.$toast({
			        message: res.message || '系统异常',
			      })
			    }
			  }, true)
			  break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style scoped>
  body {
    background-color: #F5F5F5;
  }

  .proddress_box {
    width: 100%;
    margin: 20px 0;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .proaddress_left {
    display: flex;
    align-items: center;

  }

  .proaddress_img {
    width: 18px;
    height: 18px;
    margin-right: 10px;

  }

  .proaddress_mesg {
   /* width: 70%; */
    width: 90%;
  }

  .proaddress_top {
    display: flex;
    align-items: center;
  }

  .proaddress_name {
    font-size: 15px;
    margin-right: 10px;
  }

  .proaddress_phone {
    font-size: 15px;

  }

  .proaddress_address {
    font-size: 12px;
    color: #666666;
  }

  .proaddress_rightimg {
    width: 11px;
    height: 11px;
  }

  .proaddress_right1 {
    display: flex;
    align-items: center;
  }

  .moren {
    color: #666666;
    font-size: 12px;
    margin-right: 10px;
  }

  .prodetail_mesg {
    width: 100%;
    margin-bottom: 20px;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .prodetailmesg_top {
    display: flex;
    align-items: center;

  }

  .prodetailmesg_icon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .prodetailmesg_title {
    font-size: 12px;
  }

  .prodetailmesg_center {
    margin: 13px 0;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .prodetail_photo {
    width: 30%;
    height: 90px;
    border-radius: 8px;
    margin-right: 10px;
  }

  .prodetailmesg_phimg {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .prodetailmesg_mesg {
    width: 70%;

  }

  .prodetailmesg_name {
    font-size: 12px;

  }

  .prodetailmesg_guige {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #666666;
    margin: 10px 0;
  }

  .prodetailmesg_morenguige {}

  .prodetailmesg_num {}

  .prodetailmesg_price {
    color: #FD8C00;
    font-size: 12px;
  }

  .prodetailmesg_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .prodetailmesg_heji {
    font-size: 12px;

  }

  .prodetailmesg_pricemum {
    font-size: 12px;
    color: #FD8C00;
  }

  .prodetail_liuyan {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .prodetail_payamount{
    margin-top: 20px;
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tiptest{
    width: 100%;
    padding: 10px 20px;
    margin-top: 20px;
    box-sizing: border-box;
    color: #666666;
  }
  .pay_checkbox{
    width: 14px;
    height: 14px;
  }
  .jifenlogo{
    width: 17px;
    height: 17px;
    margin-right: 10px;
  }

  .prodetail_beizhu {
    width: 100%;
    min-height: 100px;
    border: 1px solid #D2D2D2;
    margin-top: 15px;
  }

  .prodetailbuy_buttom {
    width: 100%;
    height: 56px;
    background: #fff;
    /* box-shadow: 0px -4px 5px 2px #BBBBBB; */
    box-shadow:0 -4px 5px 2px rgba(187,187,187,0.3);
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    bottom: 0;
  }

  .prodetailbuy_paynum {
    font-size: 15px;
  }

  .prodetailbuy_paybotton {
    width: 153px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/projectBuy.vue